import { OFFER_STATUS } from 'constants/offer';

import type { TOffer } from 'shared/types/TRankingService';

import { OFFER_NOTE_TEXTS_FD } from '../config/offerNote.texts';
import type { IOfferNoteData } from '../types';

import { appendInlinePhoneToTitle } from './appendInlinePhoneToTitle';

export const createOfferNoteDataForFDPage = (offer: TOffer): IOfferNoteData | null => {
  if (offer.status === OFFER_STATUS.QUEUED) {
    return OFFER_NOTE_TEXTS_FD.queued;
  }

  if (offer.status === OFFER_STATUS.ACCEPTED) {
    return OFFER_NOTE_TEXTS_FD.accepted;
  }

  if (offer.status === OFFER_STATUS.PREAPPROVED) {
    return OFFER_NOTE_TEXTS_FD.preapproved;
  }

  if (offer.status === OFFER_STATUS.APPROVED) {
    return OFFER_NOTE_TEXTS_FD.approved;
  }

  if (offer.status === OFFER_STATUS.REFUSED || offer.status === OFFER_STATUS.FAILED) {
    return OFFER_NOTE_TEXTS_FD.refused;
  }

  if (offer.status === OFFER_STATUS.ALREADY_SENT_FROM_SAME_BANK) {
    return {
      ...OFFER_NOTE_TEXTS_FD.alreadySent,
      title: appendInlinePhoneToTitle(OFFER_NOTE_TEXTS_FD.alreadySent.title, offer.phones),
    };
  }

  if (offer.status === OFFER_STATUS.ISSUED) {
    return OFFER_NOTE_TEXTS_FD.issued;
  }

  if (offer?.additionalInfo?.authLink) {
    return OFFER_NOTE_TEXTS_FD.preapproved;
  }

  return null;
};
